// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3Sl1E","subheader":"ReorderModal_subheader__1mk0z","listWrap":"ReorderModal_listWrap__3P7ub","inactiveWrap":"ReorderModal_inactiveWrap__3MuiZ"};